<template>
  <el-dialog
    title="视频"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <YPlay :videoUrl="videoUrl" controls ref="YPlay" width="100%" height="100%"></YPlay>
    <!-- <span slot="footer" class="dialog-footer">
    <el-button @click="dialogVisible = false">取 消</el-button>
    <el-button type="primary" @click="dialogVisible = false">确 定</el-button>
  </span> -->
  </el-dialog>
</template>

<script>
import YPlay from '@/components/y-player.vue';

export default {
  name: 'videoDialog',
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    videoUrl: {
      type: String,
      default: '',
    },
  },
  components: { YPlay },
  data() {
    return {
    };
  },
  methods: {
    handleClose() {
      this.$emit('update:dialogVisible', false);
      this.$refs.YPlay.closeVideo();
    },
  },
};
</script>

<style>
</style>
